import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import auth from '@/store/auth';
import campaign from '@/store/campaign';
import { RootState, TLocalErrorFieldInput } from '@/types';
import statistics from '@/store/statistics';
import publisher from '@/store/publisher';
import audience from '@/store/audience';
import dictionary from '@/store/dictionary';
import campaignGroups from '@/store/campaignGroups';
import campaignCreatives from '@/store/campaignCreatives';
import campaignSites from '@/store/campaignSites';
import dashboard from '@/store/dashboard';
import reportBuilder from '@/store/reportBuilder';
import { Notification } from 'uiv';
import i18n from '@/i18n';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  state: {
    version: '1.0.0',
    loader: false,
    sideBarMini: true,
    pageTitle: '',
    showHeader: true,
    validationErrors: [] as Array<TLocalErrorFieldInput>,
  },

  mutations: {
    changeSideBarMini(state): void {
      localStorage.sideBar = !state.sideBarMini;
      state.sideBarMini = !state.sideBarMini;
    },
    initSideBarMini(state) {
      state.sideBarMini = localStorage.sideBar === 'true';
    },
    changeTitle(state, title: string): void {
      state.pageTitle = title;
    },
    changeShowHeader(state, value) {
      state.showHeader = value;
    },
    setValidationErrors(state: RootState, errors: TLocalErrorFieldInput): void {
      state.validationErrors.push(errors);
    },
    removeLastValidationErrors(state: RootState, id: number): void {
      state.validationErrors = state.validationErrors.filter(
        (errors) => errors.id !== id
      );
    },
  },

  getters: {
    showHeader(state): boolean {
      return state.showHeader;
    },
    sidebarMini(state): boolean {
      return state.sideBarMini;
    },
    hasValidationErrors(state: RootState): boolean {
      return state.validationErrors.some((e) => e.errors.length);
    },
  },

  actions: {
    invalidFormNotification() {
      Notification.notify.warning({
        title: i18n.t('notifications.checkForm'),
        duration: 3000,
      });
    },
    invalidFormNotificationFromBackend(_, campaignId) {
      Notification.notify.warning({
        title: i18n.t('notifications.invalidCampaignForm', { campaignId }),
        content: `
        <a href="/campaign/update/${campaignId}?validate=1" class="underline">
          ${i18n.t('notifications.clickCheckForm')}
        </a>`,
        html: true,
        duration: 6000,
      });
    },
  },
  modules: {
    auth,
    campaign,
    statistics,
    publisher,
    audience,
    dictionary,
    campaignGroups,
    campaignCreatives,
    campaignSites,
    dashboard,
    reportBuilder
  },
};

export const getStore = () => store;

export default new Vuex.Store<RootState>(getStore());
